module.exports = __webpack_public_path__ + "static/media/ic_cross.d54793d0.svg";